import React from 'react'
import Title from 'components/Title/Title';

const regulation = () => {
  return (
    <div className="font-Text-R">
      <div className="px-3 sm:px-10 md:px-20 lg:px-32 py-7 ">
        <div className=' bg-gray-light rounded-lg text-black'>
          <div className='py-10'>            
            <Title text="Reglamento"/>
            <div className="px-3 sm:px-5 lg:px-12">
              <div className="sm:px-5">
                <h3 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  FECHA 
                </h3>
                <p className="font-bold">
                  SABADO 25 DE ABRIL - 15:00 HS
                </p>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  REGLAS GENERALES PARA LOS PARTICIPANTES
                </h4>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  Largada
                </h4>
                <p className="font-bold">
                  Gimnasio Polideportivo Roberto Monteros (Escondido)
                </p>
                <p className="font-bold">
                  Hora: 15:00hs
                </p>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  Disciplina
                </h4>
                <p className="font-bold">
                  Trail Running.
                </p>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  Modalidad
                </h4>
                <p className="font-bold">
                  La modalidad de dicha carrera se va a dar en fomar individual.
                </p>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  Distancia
                </h4>
                <ul className='list-decimal pl-5 font-Header-Bd'>
                  <li className="pt-5 font-bold">
                    Prueba central: 15 Km
                  </li>
                  <li className="pt-5 font-bold">
                    Prueba central: 7 Km
                  </li>
                  <li className="pt-5 font-bold">
                    Prueba central: 3 Km
                  </li>
                </ul>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  A) PARTICIPANTES
                </h4>
                <p className="font-bold">
                  INDIVIDUAL (Edades computadas al día de la competencia)
                </p>
                <p className="font-bold pt-5">
                  CATEGORÍAS POR EDADES: 15Km
                </p>
                <ul className='list-decimal pl-5'>
                  <li className="pt-5">
                    MASCULINOS Y FEMENINOS HASTA 19 AÑOS
                  </li>
                  <li className="pt-5">
                    MASCULINOS Y FEMENINOS DE 20 A 29 AÑOS
                  </li>
                  <li className="pt-5">
                    MASCULINOS Y FEMENINOS DE 30 A 39 AÑOS
                  </li>
                  <li className="pt-5">
                    MASCULINOS Y FEMENINOS DE 40 A 49 AÑOS
                  </li>
                  <li className="pt-5">
                    MASCULINOS Y FEMENINOS DE 50 A 59 AÑOS
                  </li>
                  <li className="pt-5">
                    MASCULINOS Y FEMENINOS +60 AÑOS
                  </li>
                </ul>
                <h4 className="text-[1.1rem] text-red-500 pt-5 font-Header-B">
                  Nota Importante: Aquellos corredores que no cumplan 18 años a la fecha de la carrera, deberán presentar al momento de la acreditación una autorización de padre/madre o tutor para poder participar y copia de la ficha de inscripción firmada por el participante y por el padre/madre o tutor.
                </h4>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  B) PREMIACIÓN
                </h4>
                <p className='font-bold'>
                  Prueba de 15Km y 7Km
                </p>
                <ul className='list-decimal pl-5 font-bold'>
                  <li>
                    Medalla de Finalista a todos los que crucen la meta.
                  </li>
                  <li>
                    Medallones a los 1°, 2°, 3° de cada categoría masculina y femenina.
                  </li>
                </ul>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  C) REMERA DE LA COMPETENCIA Y NÚMERO IDENTIFICATORIO
                </h4>
                <p className='font-bold'>
                  La remera de corredor es de uso obligatorio, con el número abrochado al frente sin ocultar sus partes.
                </p>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  D) SERVICIOS, ASISTENCIA, HIDRATACIÓN Y CONTROLES
                </h4>
                <ul className='list-decimal pl-5 font-bold'>
                  <li>
                    En puntos intermedios del recorrido y en la llegada se montará un puesto de asistencia e hidratación. (Solamente en 15Km)
                  </li>
                  <li>
                    A lo largo del recorrido se establecerán controles de paso de los corredores.
                  </li>
                </ul>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  E) PENALIDADES
                </h4>
                <ul className='list-decimal pl-5 font-bold'>
                  <li className='pt-5'>
                    Los participantes no pueden ser acompañados por bicicletas, automóviles, motocicletas ni otro tipo de vehículo, de ser observada esta situación por un Fiscal de la organización, será penalizado con:
                  </li>
                  <ul className='list-disc pl-5 font-bold'>
                    <li className='pt-5'>
                      1° Observación: Llamado de atención
                    </li>
                    <li className='pt-5'>
                      2° Observación: 10' de recargo
                    </li>
                    <li className='pt-5'>
                      3° Observación: Descalificación
                    </li>
                  </ul>
                  <li className='pt-5'>
                    Es obligatorio correr con la remera técnica entregada por la organización, por sobre cualquier prenda con el número completamente visible desde delante, estar sujeto por las cuatro esquinas y no debe ser cortado, doblado o escondido. La sanción por el inclumplimiento de este apartado será "el llamado de atención" y si no se rectifica, la descalificación.
                  </li>
                  <li className='pt-5'>
                    No cumplir con el recorrido oficial, obteniendo una ventaja, será motivo de descalificación.
                  </li>
                  <li className='pt-5'>
                    Está permitida la asistencia entre los corredores, excluyéndose cualquier forma que ayude en la marcha a otro corredor.
                  </li>
                </ul>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  F) REGLAS GENERALES PARA LOS PARTICIPANTES
                </h4>
                <p className='font-bold pt-2 pl-5'>
                  Los y las participantes deberán:
                </p>
                <ul className='list-decimal pl-5 font-bold'>
                  <li className='pt-5'>
                    Es responsabilidad del participante estar bien preparado para la prueba Esto es, gozar de buena salud en general,  así como tener un nivel aceptable de preparación. La inscripción en una prueba no asegura ni cubre esta responsabilidad.
                  </li>
                  <li className='pt-5'>
                    La organización recomienda que todos los participantes se realicen un control médico previo a la carrera para asegurarse estar apto para el evento.
                  </li>
                  <li className='pt-5'>
                    Es obligatorio completar la ficha de inscripción publicada en forma on line en el sitio oficial de la carrera.
                  </li>
                  <li className='pt-5'>
                    A los participantes que hayan completado la inscripción y el pago, pero decidan posteriormente no participar en la carrera, no se les reembolsará el importe abonado.  
                  </li>
                  <li className='pt-5'>
                    La organización, a través de los fiscales autorizados, se reserva el derecho de interrumpir la participación de aquellos competidores que por su condición se considere que están poniendo en riesgo su integridad física, en caso de ser indicado, es obligación del participante hacer caso a la misma. De no respetarse, será descalificado y la responsabilidad corre por cuenta del propio participante.
                  </li>
                  <li className='pt-5'>
                    La organización dispondrá ambulancias y enfermeros para la asistencia médica extra hospitalaria a quienes lo necesiten. Cada corredor está en conocimiento de las posibles consecuencias de la práctica de una actividad de este tipo, deberá por lo tanto asumir y ser responsable de cualquier gasto relacionado a emergencias médicas, salvo aquellos cubiertos por el seguro de corredor y la atención de la emergencia en terreno ya sea con la ambulancia, socorristas, enfermeros o médicos de la organización de la carrera. En caso de ser necesario, para continuar con los primeros auxilios, serán trasladados al hospital más cercano. Es fundamental que cada corredor al completar la ficha de inscripción detalle en “Observaciones” los datos de su cobertura médica y un teléfono de urgencia.
                  </li>
                  <li className='pt-5'>
                    El participante tiene la obligación de conocer y respetar estas reglas de competición, así como las normas de circulación y las instrucciones de los responsables de cada prueba.
                  </li>
                  <li className='pt-5'>
                    El participante tiene la obligación de conocer, defender y respetar el medio ambiente en el que se realiza el evento. La participación en la prueba no exime al participante de esta obligación. El mal trato o la falta de respeto hacia el medio (barda) puede ser motivo de descalificación, pudiendo llegarse a la expulsión de la competición general.
                  </li>
                  <li className='pt-5'>
                    El participante que abandona la competición está obligado a quitarse el número y comunicar a los jueces, fiscales o banderilleros su abandono, entregando el troquel del respectivo número.
                  </li>
                  <li className='pt-5'>
                    En la charla técnica, previa a largada, se brindará una explicación sobre el circuito del recorrido. En caso de que un participante se extravíe durante la competencia, por no ver una cinta, o no prestar atención a los senderos o indicaciones por parte de la organización, los corredores son responsables de volver al camino y retomar el recorrido. Ante cualquier reclamo por extravío la organización no se hace responsable.
                  </li>
                  <li className='pt-5'>
                    El recorrido podrá ser modificado antes o incluso durante el desarrollo mismo de la carrera atendiendo a razones de seguridad de los participantes u otras circunstancias que a consideración de la organización lo demanden. En caso de que la decisión sea tomada antes de la largada, los corredores serán notificados. En caso de que la decisión sea tomada durante el desarrollo de la carrera, los participantes serán informados en el puesto de control anterior a la modificación. La organización no se hará responsable de cualquier tipo de reclamo por parte de los participantes por esta causa.
                  </li>
                  <li className='pt-5'>
                    Las imágenes que se obtengan en la competencia podrán ser utilizadas por la organización y por las empresas auspiciantes para fines de difusión y publicidad del evento y/o de productos asociados al mismo.
                  </li>
                  <li className='pt-5'>
                    Los competidores que acepten participar en este evento no tendrán derecho a realizar reclamos.
                  </li>
                  <li className='pt-5'>
                    Responsabilidades: Al inscribirse, el participante acepta el presente reglamento y declara:
                    <ul className='pl-5'>
                      <li>
                        a) Saber que habrá lugares a los que no se puede acceder con vehículos, con lo cual la atención médica inmediata es limitada.
                      </li>
                      <li>
                        b) Conocer las características del terreno y los riesgos posibles de lesiones traumatológicas como torceduras, esguinces, incluso fracturas y, que por razones de seguridad, la organización priorizará la atención y evacuación de las emergencias y urgencias médicas, considerándose como tales a aquellos casos que puedan evolucionar en riesgo de muerte, pudiendo demandar más tiempo que la atención de lesiones como las antes descriptas.
                      </li>
                      <li>
                        c) Eximir a los Organizadores, Municipios, Propietarios de las tierras del circuito de la carrera y los Patrocinantes de toda responsabilidad por accidentes personales; daños y/o pérdidas de objetos que pudiera ocurrirle antes, durante o después de su participación en la prueba.
                      </li>
                    </ul>
                  </li>
                </ul>
                <h4 className="text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B">
                  G) MARCACIÓN Y LIMPIEZA
                </h4>
                <ul className='pl-5 font-bold'>
                  <li>
                    La marcación del circuito se realiza con cinta de color azul con logo propio (no
                    de ferretería) la cual al paso del último corredor la misma se va sacando y por lo
                    tanto a la finalización de la carrera ya se encuentra todo el circuito limpio. Como
                    también los puestos de agua que poseen bolsas de residuos.
                  </li>
                </ul>
                <h4 className='text-[1.2rem] text-blue-cyan font-bold pt-5 font-Header-B'>
                  H) COMUNICACIÓN
                </h4>
                <ul className='pl-5 font-bold'>
                  <li>
                    Se considera como medio oficial de comunicación de novedades la página. El participante deberá consultar periódicamente el sitio a fin de estar al tanto de novedades y posibles modificaciones en el.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default regulation